import { render, staticRenderFns } from "./WorkFlowTaskBar.vue?vue&type=template&id=62090117&scoped=true"
import script from "./WorkFlowTaskBar.vue?vue&type=script&lang=js"
export * from "./WorkFlowTaskBar.vue?vue&type=script&lang=js"
import style0 from "./WorkFlowTaskBar.vue?vue&type=style&index=0&id=62090117&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62090117",
  null
  
)

export default component.exports